export const openNewWidgetsLocales = ['us', 'de', 'uk', 'eu', 'fr', 'es', 'nl', 'it', 'jp']; //哪些站点开启了挂件配置
const item_MEMBER = {
    enable: true,
    widgetType: 'MEMBER',
    widgetIcon: 'https://websiteoss.ecoflow.com/upload/image/1767076986432/member-icon.svg',
};
const item_CHAT = {
    enable: true,
    widgetType: 'CHAT',
    widgetIcon: 'https://websiteoss.ecoflow.com/upload/image/1766146346554/icon.png',
};
const item_SHOPPING_CART = {
    enable: true,
    widgetType: 'SHOPPING_CART',
    widgetIcon: 'https://websiteoss.ecoflow.com/upload/image/1767078535439/shopping_cart.svg',
};
const defaultItems = [item_MEMBER, item_CHAT, item_SHOPPING_CART];
export const OtherLocaleSettingA: any = {
    uk: defaultItems,
    au: defaultItems,
    ca: defaultItems,
    jp: defaultItems,
    de: defaultItems,
    fr: defaultItems,
    eu: defaultItems,
    kr: defaultItems,
    cn: [item_CHAT],
    es: [item_MEMBER, item_SHOPPING_CART],
    it: [item_MEMBER, item_SHOPPING_CART],
    za: defaultItems,
    sa: [],
    tw: [],
    br: [],
    mx: [],
    ph: [item_MEMBER],
};
